module.exports = __webpack_public_path__ + "img/Icon-Notes-white.080010ae.svg";